import { Step } from "intro.js";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import feature_infos from "shared/assets/onboarding/feature_infos.gif";
import first_step from "shared/assets/onboarding/first_step.jpg";
import last_step from "shared/assets/onboarding/last_step.jpg";
import map_location from "shared/assets/onboarding/map_location.gif";

export const ViewSteps = (linref: boolean) => {
  const { t } = useTranslation();

  const steps = useMemo(() => {
    const introductionSteps: Array<Step> = [
      {
        title: t("onboarding_view.title_1") as string,
        intro:
          `<img loading='lazy' alt='Designed by pch.vector / Magnific' src='${first_step}'/>` +
          t("onboarding_view.description_1"),
      },
      {
        element: ".mapillary-direction-perspective",
        position: "top",
        title: t("onboarding_view.title_3") as string,
        intro: t("onboarding_view.description_3"),
      },
      {
        element: "#cockpit",
        position: "top",
        title: t("onboarding_view.title_4") as string,
        intro: linref
          ? t("onboarding_view.description_4_linref")
          : t("onboarding_view.description_4"),
      },
      {
        element: ".onboarding-mapBox",
        position: "left",
        title: t("onboarding_view.title_5") as string,
        intro:
          `<img loading='lazy' alt='Map tutorial' src='${map_location}'/>` +
          t("onboarding_view.description_5"),
      },
      {
        element: "#toolbar",
        position: "right",
        title: t("onboarding_view.title_6") as string,
        intro: t("onboarding_view.description_6"),
      },
      {
        element: ".onboarding-layertree",
        position: "right",
        title: t("onboarding_view.title_7") as string,
        intro: t("onboarding_view.description_7"),
      },
      {
        element: ".onboarding-featureTable",
        position: "right",
        title: t("onboarding_view.title_9") as string,
        intro: t("onboarding_view.description_9"),
      },

      {
        element: ".onboarding-featureInfo",
        position: "right",
        title: t("onboarding_view.title_10") as string,
        intro:
          `<img loading='lazy' alt='Feature info tutorial' src='${feature_infos}'/>` +
          t("onboarding_view.description_10"),
      },
      {
        element: "#infra3d-axisVisibilityPanelButton",
        position: "right",
        title: t("onboarding_view.title_11") as string,
        intro: t("onboarding_view.description_11"),
      },
      {
        element: ".onboarding-imageInformation",
        position: "right",
        title: t("onboarding_view.title_15") as string,
        intro: t("onboarding_view.description_15"),
      },
      {
        element: ".onboarding-shareLink",
        position: "right",
        title: t("onboarding_view.title_16") as string,
        intro: t("onboarding_view.description_16"),
      },
      {
        element: ".onboarding-campaignSwitch",
        position: "left",
        title: t("onboarding_view.title_17") as string,
        intro: t("onboarding_view.description_17"),
      },
      {
        element: ".onboarding-knowledgeBase",
        position: "left",
        title: t("onboarding_view.title_18") as string,
        intro: t("onboarding_view.description_18"),
      },
      {
        element: "#logo",
        position: "left",
        title: t("onboarding_view.title_19") as string,
        intro: t("onboarding_view.description_19"),
      },
      {
        element: ".onboarding-platform",
        position: "left",
        title: t("onboarding_view.title_20") as string,
        intro: t("onboarding_view.description_20"),
      },
      {
        title: t("onboarding_view.title_21") as string,
        intro:
          `<img loading='lazy' alt='Designed by pch.vector / Magnific' src='${last_step}'/>` +
          t("onboarding_view.description_21"),
      },
    ];

    return { introductionSteps };
  }, [t, linref]);

  return steps;
};
